// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { Trans } from 'react-i18next'
import dayjs from 'dayjs'

import { Typography } from '../components'

import { displayNotification } from './notificiation-utils'

export const getStatusForMultiStatusResponse = (response) => {
  let status = 'info'

  if (
    Boolean(response?.data?.failed?.length > 0) &&
    Boolean(response.data?.success?.length > 0)
  ) {
    status = 'warning'
  } else if (
    Boolean(response?.data?.failed?.length > 0) &&
    (!response?.data?.success || Boolean(response?.data?.success?.length === 0))
  ) {
    status = 'error'
  }
  return status
}

export const getNotificationMessageForMultiStatusResponse = (
  smsg,
  stype,
  fmsg,
  ftype
) => {
  return (
    <>
      {smsg && stype && (
        <>
          <Typography type="text" testId="sa-notification-desc" weight="bold">
            {stype}
          </Typography>

          <Typography
            level="7"
            wordBreak="break-word"
            color="text-strong"
            type="text"
            testId="sa-notification-title"
          >
            {smsg}
          </Typography>
        </>
      )}

      {fmsg && ftype && (
        <>
          <Typography type="text" testId="sa-notification-desc" weight="bold">
            {ftype}
          </Typography>

          <Typography
            level="7"
            wordBreak="break-word"
            color="text-strong"
            type="text"
            testId="sa-notification-title"
          >
            {fmsg}
          </Typography>
        </>
      )}
    </>
  )
}

export const CheckResourcePermissions = (roleDetails, rbacPolicies) => {
  let output = true
  Object.entries(roleDetails).forEach(([resource, permissionsArray]) => {
    const permissions = rbacPolicies?.effects?.[resource]
    if (permissions) {
      permissionsArray.forEach((permission) => {
        if (permissions[permission] === false) {
          output = false
        }
      })
    } else {
      output = false
    }
  })
  return output
}

export const multiStatusNotification = (
  response,
  setNotifyComponent,
  successMessage,
  partialApprovalMessage,
  successHeading,
  errorHeading,
  t
) => {
  if (!errorHeading) {
    errorHeading = t('manage:error')
  } else if (!successHeading) {
    successHeading = t('manage:success')
  }
  const { success, failed } = response.data
  const successCases = success?.join(', ')
  const failedCases = failed
    ?.map((failedUser) => {
      const [caseId, errorMsg] = Object.entries(failedUser)[0]
      return t('{{errorMsg}}', { case: caseId, errorMsg })
    })
    .join('\n')

  const approveSuccessMsg = successCases && (
    <Trans i18nKey={successMessage} values={{ cases: successCases }} />
  )

  const approveFailedMsg = failedCases && `\n ${failedCases}`

  const status = getStatusForMultiStatusResponse(response)
  const autoClose = !(failed?.length > 0 && success?.length > 0)

  let notifyHeading = ''
  if (success?.length > 0 && failed?.length > 0) {
    notifyHeading = t(partialApprovalMessage)
  } else if (success?.length > 0) {
    notifyHeading = t(successHeading)
  }

  const notification = displayNotification(
    getNotificationMessageForMultiStatusResponse(
      approveSuccessMsg,
      notifyHeading,
      approveFailedMsg,
      t(errorHeading)
    ),
    status,
    setNotifyComponent,
    '',
    autoClose
  )

  return notification
}

export const getCCSAppDetails = () => {
  return {
    ccsApplicationId: '00000000-0000-0000-0000-000000000000',
    ccsApplicationName: 'Common Cloud Service'
  }
}

export const checkIfAll = (allPref, selectedPref) => {
  return (
    allPref?.length &&
    selectedPref?.length &&
    allPref.length === selectedPref.length &&
    allPref.every((element, index) => {
      return element === selectedPref[index]
    })
  )
}

export const getStatusIdentifiers = (statusList) => {
  const statusMap = {
    Critical: 1,
    Information: 0,
    Warning: 2,
    Ok: 3
  }

  const statusIdentifiers = []
  statusList.map((s) => statusIdentifiers.push(statusMap[s]))
  return statusIdentifiers
}

export const statusArr = ['Information', 'Critical', 'Warning', 'Ok']

export const getStatusList = (statusIdentifier) => {
  const statusList = []
  statusIdentifier.map((i) => statusList.push(statusArr[i]))
  return statusList
}

export const convertUTCToLocalTime = (publishDateUTC = {}) => {
  const publishTime = publishDateUTC?.time || ''
  const publishDate = dayjs(publishDateUTC?.date).format('YYYY-MM-DD')
  const [time, meridian] = publishTime.split(' ')
  let hour = time.split(':')[0]
  const minute = time.split(':')[1]
  hour = parseInt(hour, 10)
  if (meridian === 'pm' && hour < 12) {
    hour += 12
  } else if (meridian === 'am' && hour === 12) {
    hour = 0
  }

  hour = hour.toString().padStart(2, '0')
  const ISOFormatDateInput = `${publishDate}T${hour}:${minute}:00Z`
  const dateObj = new Date(ISOFormatDateInput)

  const localTimeFormat = dayjs(dateObj).format('MM/DD/YYYY hh:mm a')
  return localTimeFormat
}
